import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ContentItemGrid from 'js/components/content-item/ContentItem.grid';
import FilterGridOptions from './FilterGrid.options';

// import actions
import { setData, setShowMore, setFilter, removeFilter } from 'js/store/content-filter/ContentFilter.actions.js';

// import selectors
import { getFilterContentByDisplayCount, getCanShowMore } from 'js/store/content-filter/ContentFilter.selectors.js';

const FilterGridIndex = ({ title = '', type = '' }) => {
  const dispatch = useDispatch();

  if (type === '') return null;

  useEffect(() => {
    dispatch(setData(type));
  }, []);

  const data = useSelector((state) => {
    return getFilterContentByDisplayCount(state) || [];
  });

  const canShowMore = useSelector((state) => {
    return getCanShowMore(state);
  });

  return (
    <div className={'filter-grid' + (type ? ' filter-grid--' + type : '')}>
      {title !== '' && <h2 className={'filter-grid__title' + (type ? ' filter-grid__title--' + type : '')}>{title}</h2>}

      {/* <FilterGridOptions /> */}
      <ContentItemGrid data={data} />

      {canShowMore && (
        <button className="filter-grid__show-more" onClick={() => dispatch(setShowMore())}>
          Show More
        </button>
      )}
    </div>
  );
};

export default FilterGridIndex;
